import axiosInstance from '../core/axiosconfig'; 
import axios from 'axios';
export const cleanCustomerId = (customerId) => {
    if (!customerId) return '';
    
    return customerId
      .replace(/\\/g, '')    // Remove backslashes
      .replace(/"/g, '')     // Remove quotes
      .trim();               // Remove whitespace
  };
  const axiosInstance1 = axios.create({
    baseURL: window._env_.SERVER_URL,
  });
  
  axiosInstance1.interceptors.request.use(config => {
    const token = localStorage.getItem('token1');
    if (token) {
      config.headers['X-Authorization'] = `Bearer ${token}`;
    }
    return config;
  });
  export default axiosInstance1;

  export const customerbasedshift = async (customerId,key) => {
    try {
        const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const cleanedCustomerId = cleanCustomerId(customerId);

        const url = `${baseUrl}/api/plugins/telemetry/CUSTOMER/${cleanedCustomerId}/values/attributes?keys=${key}`;

      console.log('Shift API URL:', url);
  
      const response = await axiosInstance.get(url);
      console.log('Shift API Response:', response); // <-- Add this
  
      return response.data;
    } catch (error) {
      console.error('Error during Shift latest data:', error);
      throw error;
    }
  };
  export const shiftadd = async (shiftdata,customerId,scope) => {
    try {
      const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const cleanedCustomerId = cleanCustomerId(customerId);
      const response = await axiosInstance1.post(`${baseUrl}/api/plugins/telemetry/CUSTOMER/${cleanedCustomerId}/${scope}`, shiftdata);
      // /api/plugins/telemetry/{entityType}/{entityId}/{scope}
      console.log('Response' ,response)
      return response.data; // Return the response data
    } 
    catch (error) {
      console.error('Error during login:', error);
      throw error; // Rethrow the error to handle it in the calling function
    }
  };

  // ───────────────────────────────────────────────────────────────────────────
  // Safe master-data writes (component / reason / operator / shift / …).
  //
  // Every master list is stored as ONE ThingsBoard CUSTOMER attribute (a single
  // JSON array per key). Each save overwrites the whole array, so a payload built
  // from stale/empty client state silently wipes the list ("N items replaced by
  // 1"). These helpers make the write defensive WITHOUT a backend:
  //   • getMasterList        – always read the fresh server list
  //   • saveMasterListSafely – re-read → merge → guard against shrink → snapshot
  //                            the previous list → write.
  // This is a stop-gap. The durable fix is per-record CRUD on a real backend.
  // ───────────────────────────────────────────────────────────────────────────

  // Read the current server value for a master-list key, always as an array.
  // Some keys were historically stored as a JSON string, so parse that too.
  export const getMasterList = async (customerId, key) => {
    const res = await customerbasedshift(customerId, key);
    let val = res?.[0]?.value;
    if (typeof val === 'string') {
      try { val = JSON.parse(val); } catch { /* not JSON — leave as-is */ }
    }
    return Array.isArray(val) ? val : [];
  };

  const MASTER_BACKUP_KEEP = 5;

  // Snapshot the previous list into a rolling `<key>_bak` attribute so we always
  // have the last few good versions, independent of TB audit-log retention.
  // Best-effort: a failed backup must never block the real save.
  const backupMasterList = async (customerId, key, prevList, scope) => {
    if (!Array.isArray(prevList) || prevList.length === 0) return;
    try {
      const bakKey = `${key}_bak`;
      const res = await customerbasedshift(customerId, bakKey);
      const history = Array.isArray(res?.[0]?.value) ? res[0].value : [];
      const nextHistory = [
        { ts: Date.now(), count: prevList.length, list: prevList },
        ...history,
      ].slice(0, MASTER_BACKUP_KEEP);
      await shiftadd({ [bakKey]: nextHistory }, customerId, scope);
    } catch (e) {
      console.warn(`[master-backup] snapshot failed for ${key}:`, e?.message || e);
    }
  };

  // Thrown when a save would shrink the list below the known-good baseline —
  // the exact signature of the data-loss bug. Callers can catch by `.code`.
  export class MasterShrinkError extends Error {
    constructor(prevCount, nextCount, key) {
      super(
        `Refusing to save "${key}": the list would shrink from ${prevCount} to ` +
        `${nextCount}. This looks like accidental data loss, so nothing was written.`
      );
      this.name = 'MasterShrinkError';
      this.code = 'MASTER_SHRINK_GUARD';
      this.prevCount = prevCount;
      this.nextCount = nextCount;
    }
  }

  /**
   * Safe read-modify-write for a single-attribute master list.
   *
   * @param {object}   opts
   * @param {string}   opts.customerId
   * @param {string}   opts.key            attribute key, e.g. "component"
   * @param {function} opts.mutate         (freshServerList) => newList — build the new array here
   * @param {string}   [opts.scope]        TB scope (default SERVER_SCOPE)
   * @param {number}   [opts.baselineCount] what the client currently shows (e.g. datasource.length);
   *                                        guards against a spurious empty re-read wiping real data
   * @param {boolean}  [opts.allowShrink]  set true ONLY for genuine delete flows
   * @param {object}   [opts.extra]        extra sibling attributes to write alongside [key]
   * @param {function} [opts.deriveExtra]  (finalList) => ({...}) — extra siblings computed
   *                                        from the merged list (e.g. shift breakdetails)
   */
  export const saveMasterListSafely = async ({
    customerId,
    key,
    mutate,
    scope = 'SERVER_SCOPE',
    baselineCount = 0,
    allowShrink = false,
    extra = {},
    deriveExtra,
  }) => {
    // 1) Always build on the CURRENT server list, never on stale client state.
    const freshList = await getMasterList(customerId, key);
    const nextList = mutate(freshList.slice());
    if (!Array.isArray(nextList)) {
      throw new Error('saveMasterListSafely: mutate() must return an array');
    }

    // 2) Guard the wipe. (Disabled by request - do not block saving)
    // const baseline = Math.max(freshList.length, baselineCount || 0);
    // if (!allowShrink && nextList.length < baseline) {
    //   throw new MasterShrinkError(baseline, nextList.length, key);
    // }

    // 3) Snapshot the previous list, then write the new one.
    await backupMasterList(customerId, key, freshList, scope);
    const payload = {
      [key]: nextList,
      lastUpdateTs: Date.now(),
      ...extra,
      ...(typeof deriveExtra === 'function' ? deriveExtra(nextList) : {}),
    };
    return shiftadd(payload, customerId, scope);
  };

  export const Downtimeadd = async (entityType, entityId, scope, thresholddata) => {
    try {
        const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/attributes/${scope}`;
        
        console.log('Device Shift API URL:', url);
  
        const response = await axiosInstance.post(url, thresholddata);
        console.log('Device Shift API Response:', response);
  
        return response.data;
    } catch (error) {
        console.error('Error during Device Shift update:', error);
        throw error;
    }
  };

  export const Downtimeadd1 = async (entityType, entityId, scope, thresholddata) => {
    try {
        const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/${scope}`;
        
        console.log('Device Shift API URL:', url);
  
        const response = await axiosInstance.post(url, thresholddata);
        console.log('Device Shift API Response:', response);
  
        return response.data;
    } catch (error) {
        console.error('Error during Device Shift update:', error);
        throw error;
    }
  };
  export const DowntimeaddDelete = async (entityType, entityId, key, starttime, endtime) => {
    try {
      const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
      const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/delete?keys=${encodeURIComponent(key)}&startTs=${starttime}&endTs=${endtime}`;
      console.log('Timeseries Delete API URL:', url);
  
      const response = await axiosInstance.delete(url);
      console.log('Timeseries Delete API Response:', response);
  
      if (response.status === 200 || response.status === 204) {
        return true; // ✅ Successful delete
      } else {
        return false; // ❌ Something went wrong
      }
    } catch (error) {
      console.error('Error during Device Shift update:', error);
      throw error; // Let caller handle it
    }
  };

  export const DowntimeaddDelete1 = async (entityType, entityId, key, starttime, endtime) => {
    try {
      const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
      const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/delete?keys=${encodeURIComponent(key)}&startTs=${starttime}&endTs=${endtime}`;
      console.log('Timeseries Delete API URL:', url);
  
      const response = await axiosInstance1.delete(url);
      console.log('Timeseries Delete API Response:', response);
  
      if (response.status === 200 || response.status === 204) {
        return true; // ✅ Successful delete
      } else {
        return false; // ❌ Something went wrong
      }
    } catch (error) {
      console.error('Error during Device Shift update:', error);
      throw error; // Let caller handle it
    }
  };
  
  export const Downtimeadd2 = async (entityType, entityId, scope, thresholddata) => {
    try {
        const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/${scope}`;
        
        console.log('Device Shift API URL:', url);
  
        const response = await axiosInstance1.post(url, thresholddata);
        console.log('Device Shift API Response:', response);
  
        return response.data;
    } catch (error) {
        console.error('Error during Device Shift update:', error);
        throw error;
    }
  };
  export const Deviceattributeget = async (customerId,key) => {
    try {
        const baseUrl = window._env_.SERVER_URL.replace(/\/$/, ''); // Remove trailing slash if any
        const cleanedCustomerId = cleanCustomerId(customerId);

        const url = `${baseUrl}/api/plugins/telemetry/DEVICE/${customerId}/values/attributes?keys=${key}`;

      console.log(' API URL:', url);
  
      const response = await axiosInstance.get(url);
      console.log(' API Response:', response); // <-- Add this
  
      return response.data;
    } catch (error) {
      console.error('Error during Shift latest data:', error);
      throw error;
    }
  };